/*
  A cert number as a visitor types it, made into the one the catalogue stores
  (docs/specs/pop-language-split.md D26, Robert, 2026-10-20).

  Cert numbers are nine digits with their leading zeros — the slab label reads
  `000053600` — but nobody types them that way. They type `53600`, or copy `#53600` off
  an email, or `PCG 53600` / `PCG-53600` off the label. All of those mean the same slab,
  so all of them become `000053600` before the search is sent.

  The live API happens to match an unpadded number already. Padding here is what keeps
  the page from depending on that: a backend that tightens to an exact match would
  otherwise turn every short cert number into "no results" without a line changing here.

  Anything that is not a cert number once the prefixes are off — a card name, a set name,
  or ten or more digits, which no cert has — comes back trimmed and otherwise untouched.
  The inner pages' single box sends one string as both a card name and a cert number
  (useOr), so this must never mangle the card-name reading of it.
*/

const CERT_DIGITS = 9;

/* A leading `#`, then a leading `PCG` or `PCG-`, either case. Spaces are already gone. */
const CERT_PREFIX = /^#?(?:pcg-?)?/i;

const DIGITS_ONLY = new RegExp(`^\\d{1,${CERT_DIGITS}}$`);

export const normaliseCertNumber = (input: string): string => {
  const trimmed = input.trim();
  const digits = trimmed.replace(/\s+/g, "").replace(CERT_PREFIX, "");

  return DIGITS_ONLY.test(digits) ? digits.padStart(CERT_DIGITS, "0") : trimmed;
};
